import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getCategoryListSucceed, requestFailure } from '../actions'

export function* getCategoryListSaga(
  categoryApi: {
    getCategoryList: (...args: any[]) => any
  },
  {
    payload: { page, limit, sortBy, sortDirection, q }
  }: {
    payload: {
      page?: number
      limit?: number
      sortBy?: string
      sortDirection?: string
      q?: string
    }
  }
) {
  try {
    const { data } = yield call(
      categoryApi.getCategoryList,
      page,
      limit,
      sortBy,
      sortDirection,
      q
    )
    yield put(getCategoryListSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
